
import { Button } from "@/components/ui/button";
import { Eye, Edit2, Loader2 } from "lucide-react";

interface DocumentEditActionsProps {
  isEditing: boolean;
  isLoading: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
}

export function DocumentEditActions({
  isEditing,
  isLoading,
  onEdit,
  onSave,
  onCancel
}: DocumentEditActionsProps) {
  return (
    <div className="mt-4 flex justify-end gap-2 px-6 pb-2">
      <Button 
        onClick={isEditing ? onSave : onEdit} 
        variant={isEditing ? "default" : "outline"}
        disabled={isLoading}
        className="flex items-center gap-2"
      >
        {isLoading && <Loader2 className="h-4 w-4 animate-spin" />}
        {isEditing ? (
          <>
            {isLoading ? "Lagrer..." : "Lagre endringer"}
          </>
        ) : (
          <>
            <Edit2 className="h-4 w-4" />
            Rediger
          </>
        )}
      </Button>
      {isEditing && (
        <Button
          onClick={onCancel}
          variant="outline"
          disabled={isLoading}
          className="flex items-center gap-2"
        >
          <Eye className="h-4 w-4" />
          Avbryt
        </Button>
      )}
    </div>
  );
}
